import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Typography } from 'kangarootime-ui';
import './Row.css';

const StyledTypography = props => <Typography style={{ fontSize: '0.825rem', fontWeight: '500' }}>{props.children}</Typography>;

const Row = ({
  message,
  ...props
}) => {
  const formatDateTime = date => moment(date).format('M-D-YYYY, h:mm A');
  let channelType = message.channel.private ? '(Private)' : '(Public)';
  const isDirectMessage = message.channel.directMessage;
  const isBroadcast = message.channel.broadcastType;

  if (isDirectMessage) {
    channelType = '(Direct Message)';
  }

  if (isBroadcast) {
    channelType = '(Broadcast)';
  }

  return (
    <tr className='overview-table-row'>
      <td style={{ textAlign: 'center' }}>
        <StyledTypography>{formatDateTime(message.createdAt)}</StyledTypography>
      </td>
      <td style={{ textAlign: 'center' }}>
        <StyledTypography>{message.channel.name} {channelType}</StyledTypography>
      </td>
      <td style={{ textAlign: 'center' }}>
        <StyledTypography>{message.user.name}</StyledTypography>
      </td>
      <td style={{ textAlign: 'center' }}>
        <StyledTypography>{message.message}</StyledTypography>
      </td>
    </tr>
  );
};

Row.propTypes = {
  message: PropTypes.object
};

export default Row;
